import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationsService } from "../../shared/services/notifications.service";
import { NotificationNavigationService } from "../../shared/services/notification-navigation.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-notification-redirect",
  templateUrl: "./notification-redirect.component.html",
})
export class NotificationRedirectComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly notificationService: NotificationsService,
    private readonly notificationNav: NotificationNavigationService,
    private readonly toastr: ToastrService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.queryParamMap.get("xk9qz2");
    if (!id) {
      this.toastr.error("Invalid notification link");
      this.router.navigate(["/"]);

      return;
    }
    this.notificationService.getNotificationById(id).subscribe({
      next: (notification: any) => this.notificationNav.navigate(notification),
      error: () => {
        this.toastr.error("This notification could not be found");
        this.router.navigate(["/"]);
      },
    });
  }
}
